import type { RGBA, WindVector } from './types';

export const NULL_WIND_VECTOR: WindVector = [NaN, NaN, null]; // singleton for undefined location outside the vector field [u, v, mag]
export const TRANSPARENT_BLACK: RGBA = [0, 0, 0, 0]; // singleton 0 rgba
export const TAU = 2 * Math.PI;
export const VELOCITY_SCALE = 1 / 400_000;
export const H = 0.000036; // 0.0000360°φ ~= 4m
export const MAX_WIND = 30;

/**
 * @deprecated Use `WIND_COLOR_THEMES.legacy.gradient` from './colorThemes' instead.
 * Kept for backward compatibility with existing consumers.
 */
export const WIND_COLOR_SCHEME = [
  '#e6e6e630',
  '#d772d930',
  '#1c6cc1',
  '#01cb16',
  '#ff6a00',
  '#940211',
];
